import Index from '@/pages/hospital/Index'
import List from '@/pages/hospital/List'
import Create from '@/pages/hospital/Create'
import Modify from '@/pages/hospital/Modify'

var serviceName = process.env.VUE_APP_SERVICE_NAME || 'Nichibyo'

export default {
  path: 'hospital',
  component: Index,
  children: [
    {
      path: 'index',
      component: List,
      props: () => ({serviceName: serviceName})
    },
    {
      path: 'create',
      component: Create,
      props: () => ({serviceName: serviceName}),
    },
    {
      path: 'modify/:id',
      component: Modify,
      props: () => ({serviceName: serviceName}),
    },
  ]
}